import _toConsumableArray from "babel-runtime/helpers/toConsumableArray";
import _extends from "babel-runtime/helpers/extends";
import _objectWithoutProperties from "babel-runtime/helpers/objectWithoutProperties";
import builder from "./util";
import _every from "lodash/every";

var module = builder({
  getInitialState: function getInitialState() {
    return {
      answers: [],
      currentQuestionIndex: 0
    };
  },
  actions: {
    reset: function reset() {
      return function () {
        return { answers: [], currentQuestionIndex: 0 };
      };
    },
    // reset: () => () => ({
    //   answers: [true, true, true, true, true, true, true, true, true, true, true, ],
    //   currentQuestionIndex: 11,
    // }),
    answer: function answer(_ref) {
      var answers = _ref.answers,
          state = _objectWithoutProperties(_ref, ["answers"]);

      return function (answerIndex) {
        return _extends({}, state, {
          answers: [].concat(_toConsumableArray(answers), [answerIndex])
        });
      };
    },
    next: function next(_ref2) {
      var currentQuestionIndex = _ref2.currentQuestionIndex,
          state = _objectWithoutProperties(_ref2, ["currentQuestionIndex"]);

      return function () {
        return _extends({}, state, {
          currentQuestionIndex: currentQuestionIndex + 1
        });
      };
    }
  }
});

module.isCompleted = function (_ref3, questions) {
  var currentQuestionIndex = _ref3.currentQuestionIndex;

  return currentQuestionIndex >= questions.length;
};

module.hasWon = function (_ref4, questions) {
  var answers = _ref4.answers;

  return questions.length === answers.length && _every(answers);
};

module.getScore = function (_ref5, questions) {
  var answers = _ref5.answers;

  return {
    number: answers.filter(function (ans) {
      return !!ans;
    }).length,
    total: questions.length
  };
};

module.getLastResult = function (_ref6) {
  var answers = _ref6.answers,
      currentQuestionIndex = _ref6.currentQuestionIndex;

  return answers.length === currentQuestionIndex + 1 ? answers[currentQuestionIndex] : null;
};

module.getCurrentQuestion = function (_ref7, questions) {
  var currentQuestionIndex = _ref7.currentQuestionIndex,
      answers = _ref7.answers;

  return currentQuestionIndex < questions.length ? questions[currentQuestionIndex] : null;
};

export default module;
//# sourceMappingURL=quizz.js.map


//////////////////
// WEBPACK FOOTER
// /Users/nicolasraynaud/Projets/jeux-mobiles-manitoba/packages/common-react/lib/stores/quizz.js
// module id = 47
// module chunks = 0